<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount, computed } from 'vue'
import CustomList from "../../../compositions/CustomList.vue";
import ModalDialog from "../../../compositions/ModalDialog.vue";
import CsvLoader from "../../../compositions/CsvLoader.vue";
import SearchBox from "../../../compositions/SearchBox.vue";
import SelectBox from "../../../compositions/SelectBox.vue";
import TextBox from "../../../compositions/TextBox.vue";
import CheckBox from "../../../compositions/CheckBox.vue";
import PharmacyMedicineEditComponent from "../../Common/PharmacyMedicineEditComponent.vue";
import config from "../../../config.js";
import { errorAlert,confirmAlert,successAlert } from "../../../plugins/alert";
import { getFieldValue } from "../../../plugins/utility";
import qs from 'qs';
import axios from '../../../plugins/axios.ts';
import HelpAction from '../../../compositions/HelpAction.vue';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    pharmacy:{
      type:Object,
      required:true,
    },
})

const element = ref();
const isLoadingDialog = ref(false);
const vanDebugRandomUndelivered = ref(props.pharmacy.van_debug_random_undelivered ? true : false);
const vanDebugRandomTelephone = ref(props.pharmacy.van_debug_random_telephone ? true : false);
const vanDebugRandomLotNo = ref(props.pharmacy.van_debug_random_lot_no ? true : false);
const vanDebugRandomNew = ref(props.pharmacy.van_debug_random_new ? true : false);
const vanDebugRandomError = ref(props.pharmacy.van_debug_random_error ? true : false);
const runMedicinePredict = async () => {
  isLoadingDialog.value = true;
  try {
    let params = {};
    const response = await axios(props.apis.debug_run_medicine_predict,{method:"post",data:params});
    if (response.data.status == 200) {
      successAlert('予測実行を予約しました。');
    } else {
      errorAlert(response.data.message);
    }

  } finally {
    isLoadingDialog.value = false;
  }
}

const runPharmacyDebug = async () => {
  isLoadingDialog.value = true;
  try {
    let params = {
      van_debug_random_undelivered:vanDebugRandomUndelivered.value,
      van_debug_random_telephone:vanDebugRandomTelephone.value,
      van_debug_random_lot_no:vanDebugRandomLotNo.value,
      van_debug_random_new:vanDebugRandomNew.value,
      van_debug_random_error:vanDebugRandomError.value,

    };
    const response = await axios(props.apis.debug_van_error_flg,{method:"post",data:params});
    if (response.data.status == 200) {
      location.reload();
    } else {
      errorAlert(response.data.message);
    }

  } finally {
    isLoadingDialog.value = false;
  }
}
</script>

<style scoped>
</style>
<template>
<div ref="element" class="relative">
  <div class="w-full flex items-center justify-end p-2 bg-gray-100 rounded h-10">
  </div>
  <div class="w-full">
      <div class="m-1 md:w-1/5">
          <a href="javascript:void(0)" @click="runMedicinePredict" class="block text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200 font-medium rounded-lg text-base px-5 py-3 w-full sm:w-auto text-center ml-2">予測実行</a>
      </div>
  </div>
  <div class="w-full">
    <div>薬局VANデバッグフラグ</div>
    <div class="border border-gray-500 p-4 m-4">
      <div class="flex flex-row items-center">
        <div>VAN受信デバッグランダム未納品追加:</div>
        <div><input type="checkbox" v-model="vanDebugRandomUndelivered"></div>
      </div>
      <div class="flex flex-row items-center">
        <div>VAN受信デバッグランダム納品追加:</div>
        <div><input type="checkbox" v-model="vanDebugRandomTelephone"></div>
      </div>
      <div class="flex flex-row items-center">
        <div>VAN受信デバッグランダムロット番号追加:</div>
        <div><input type="checkbox" v-model="vanDebugRandomLotNo"></div>
      </div>
      <div class="flex flex-row items-center">
        <div>VAN受信デバッグランダム新規追加:</div>
        <div><input type="checkbox" v-model="vanDebugRandomNew"></div>
      </div>
      <div class="flex flex-row items-center">
        <div>VAN接続ランダムエラー:</div>
        <div><input type="checkbox" v-model="vanDebugRandomError"></div>
      </div>
    </div>
    <div class="w-full">
        <div class="m-1 md:w-1/5">
            <a href="javascript:void(0)" @click="runPharmacyDebug" class="block text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200 font-medium rounded-lg text-base px-5 py-3 w-full sm:w-auto text-center ml-2">登録</a>
        </div>
    </div>
  </div>
</div>

<modal-dialog
  :is-visible="isLoadingDialog"
  width="40%"
  :isLoading="true"
>
  <template v-slot:header>
  </template>
  <template v-slot:default>
  <div class="mb-6">
    処理中です。
  </div>
  </template>
</modal-dialog>
</template>

